import { howLongAgo } from "../localization/format.ts";
import { say } from "../localization/say.ts";
import { carriesItsOwnEndpoint, howManyModels } from "./a-provider.ts";

export type HeldCredential = {
  id: string;
  provider: string;
  kind: string;
  label: string;
  maskedHint: string;

  externalLabel?: string | null;
  externalId?: string | null;

  baseUrl?: string | null;
  model?: string | null;
  expiresAt: string | null;
  addedAt: string;
  provedAt: string | null;
  lastRunAt?: string | null;
  runsLately?: number;
};

export type HeldSearchKey = {
  id: string;
  provider: string;
  label: string;
  maskedHint: string;
  addedAt: string;
  broughtBy: string;
};

export function renewsItself(held: HeldCredential): boolean {
  return held.kind === "oauth_access";
}

export function marksOf(held: HeldCredential): string[] {
  if (carriesItsOwnEndpoint(held.provider)) return [held.model ?? ""].filter(Boolean);
  return [say("providers.models")(howManyModels(held.provider))];
}

export function howItRuns(held: HeldCredential): string {
  if (carriesItsOwnEndpoint(held.provider)) return held.baseUrl ?? "";
  return held.kind === "api_key" ? held.maskedHint : "";
}

export function lastly(held: HeldCredential): string {
  if (held.lastRunAt) return say("providers.usedLately")(howLongAgo(held.lastRunAt), held.runsLately ?? 0);
  if (held.provedAt) return say("providers.proved")(howLongAgo(held.provedAt));
  return say("providers.neverProved");
}
